import supabase from '../supabase/supabase';

/**
 * Change password for authenticated user
 * @param {string} currentPassword - User's current password
 * @param {string} newPassword - New password to set
 */
export const changePassword = async (currentPassword, newPassword) => {
  try {
    const { data, error } = await supabase.functions.invoke('api', {
      body: {
        path: 'auth/change-password',
        current_password: currentPassword,
        new_password: newPassword,
      },
    });

    if (error) throw error;
    if (data?.error) throw new Error(data.error);

    return data;
  } catch (error) {
    console.error('Error changing password:', error);
    throw error;
  }
};

/**
 * Request password reset email (for forgot password flow)
 * @param {string} email - User's email address
 */
export const requestPasswordReset = async (email) => {
  try {
    const { data, error } = await supabase.functions.invoke('api', {
      body: {
        path: 'auth/request-reset',
        email: email,
      },
    });

    if (error) throw error;
    if (data?.error) throw new Error(data.error);

    return data;
  } catch (error) {
    console.error('Error requesting password reset:', error);
    throw error;
  }
};

/**
 * Update password after clicking reset link
 * Called when user has a valid recovery session
 * @param {string} newPassword - New password to set
 */
export const updatePasswordAfterReset = async (newPassword) => {
  try {
    const { data, error } = await supabase.functions.invoke('api', {
      body: {
        path: 'auth/reset-password',
        new_password: newPassword,
      },
    });

    if (error) throw error;
    if (data?.error) throw new Error(data.error);

    return data;
  } catch (error) {
    console.error('Error updating password:', error);
    throw error;
  }
};

/**
 * Update password using Supabase's built-in method
 * Alternative approach that works directly with Supabase auth
 * @param {string} newPassword - New password to set
 */
export const updatePasswordDirect = async (newPassword) => {
  try {
    const { data, error } = await supabase.auth.updateUser({
      password: newPassword,
    });

    if (error) throw error;
    return data;
  } catch (error) {
    console.error('Error updating password:', error);
    throw error;
  }
};
